import Vue from 'vue'
import Loader from './Loader'

let Instance
let LoaderNum = 0

export default {
    show (options) {
        LoaderNum += 1

        if (Instance) {
            return false
        }

        Instance = new Vue({
            render (h) {
                return h(Loader, {
                    props: options
                })
            }
        })

        const component = Instance.$mount()
        document.body.appendChild(component.$el)
    },
    hide () {
        if (!Instance) {
            return false
        }
        
        LoaderNum -= 1

        if (LoaderNum === 0) {
            Instance.$children[0].show = false
            Instance = null
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/loader/index.js